module.exports = __webpack_public_path__ + "static/media/illustration 2.5aac73a5.png";